import { BsMusicNoteBeamed } from 'react-icons/bs';
import Controls from "../Controls/Controls";
import ProgressBar from "../ProgressBar/ProgressBar";
import {useRef, useState} from "react";
import Options from "../Options/Options2";

function DisplayTrack2(props) {

    const currentTrack = props.currentTrack;
    const audioRef = props.audioRef;
    const tracks = props.tracks;
    const trackIndex = props.trackIndex;
    const setTrackIndex = props.setTrackIndex;
    const isPlaying = props.isPlaying;
    const setIsPlaying = props.setIsPlaying;
    const tracklistOpen= props.tracklistOpen;
    const setTracklistOpen= props.setTracklistOpen;


    const progressBarRef = useRef();
    const [timeProgress, setTimeProgress] = useState(0);
    const [duration, setDuration] = useState(0);

    const onLoadedMetadata = () => {
        const seconds = audioRef.current.duration;
        setDuration(seconds);
        progressBarRef.current.max = seconds;
    };

    const handleNext = () => {
        if (trackIndex >= tracks.length - 1) {
            setTrackIndex(0);
        } else {
            setTrackIndex((prev) => prev + 1);
        }
    };

    const closeTracklist = () => {
        if (tracklistOpen) {
            setTracklistOpen(!tracklistOpen)
            const image = document.querySelector(".audio-image2");
            image.style.filter = "";
        }
    }

    return (
        <div>
            <audio
                src={currentTrack.audio}
                ref={audioRef}
                onLoadedMetadata={onLoadedMetadata}
                onEnded={handleNext}
            />
            <div className="audio-info2">
                <div className="audio-image2" onClick={closeTracklist}>
                    {currentTrack.cover2 || currentTrack.cover ? (
                        <img src={currentTrack.cover2 || currentTrack.cover} alt="audio avatar" />
                    ) : (
                        <div className="icon-wrapper">
                          <span className="audio-icon">
                            <BsMusicNoteBeamed />
                          </span>
                        </div>
                    )}
                </div>
                <div className="text2">
                    <p className="title2">{currentTrack.title}</p>
                </div>
                <div className="audio-controls2">
                    <div className="audio-image-preview">
                        {currentTrack.cover2 || currentTrack.cover ? (
                            <img src={currentTrack.cover2 || currentTrack.cover} alt="audio avatar" />
                        ) : (
                            <div className="icon-wrapper">
                          <span className="audio-icon">
                            <BsMusicNoteBeamed />
                          </span>
                            </div>
                        )}
                    </div>
                    <Controls
                        audioRef={audioRef}
                        progressBarRef={progressBarRef}
                        duration={duration}
                        setTimeProgress={setTimeProgress}
                        tracks={tracks}
                        trackIndex={trackIndex}
                        setTrackIndex={setTrackIndex}
                        handleNext={handleNext}
                        isPLaying={isPlaying}
                        setIsPlaying={setIsPlaying}
                    />
                    <ProgressBar
                        progressBarRef={progressBarRef}
                        audioRef={audioRef}
                        timeProgress={timeProgress}
                        duration={duration}
                    />
                    <Options
                        audioRef={audioRef}
                        tracklistOpen={tracklistOpen}
                        setTracklistOpen={setTracklistOpen}
                    />
                </div>
            </div>
        </div>
    );
};
export default DisplayTrack2;